import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";
import { B17VALI } from "../../../Validation";
import { FormControl } from "react-bootstrap";
import { Box } from "react-bootstrap-icons";
import moment from "moment";
import ComponentLoader from "../../../../ComponentLoader";

function B17Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [authors, setAuthors] = useState("");
  const [year, setYear] = useState("");
  const [Title, setTitle] = useState("");
  const [magazineNewspaper, setMagazineNewspaper] = useState("");
  const [pageno, setpageno] = useState("");
  const [loader,setLoader] =useState(true);
  const [authorsErr, setAuthorsErr] = useState(false);
  const [yearErr, setYearErr] = useState(false);
  const [TitleErr, setTitleErr] = useState(false);
  const [magazineNewspaperErr, setMagazineNewspaperErr] = useState(false);
  const [pagenoErr, setpagenoErr] = useState(false);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(B17VALI),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head(" Popular articles");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
    setLoader(false);
  }, []);

  const edit = (item) => {
    console.log(item);
    setAuthors(item.authors);
    setYear(item.year);
    setTitle(item.articleTitle);
    setMagazineNewspaper(item.magazineNewspaper);
    setpageno(item.PagenoV);
    // setValue("ConferenceDate",moment(item.conferenceDate).format("YYYY-MM-DD"));
    // setValue("PlaceV", item.place);
    // setValue("OrganizerV", item.organizer);

    setId(item.id);
  };

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  const backs = () => {
    navigate("/B17");
  };

  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);

    const d = {
      id,
      Authors: authors,
      Year: year,
      ArticleTitle: Title,
      MagazineNewspaper: magazineNewspaper,
      PageNo: pageno,
      // Place:data.PlaceV,
      // Organizer:data.OrganizerV,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.B17SAVE}`,
          d,
          { headers: h }
        );
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfly Submited");
          navigate("/B17");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }

        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.B17EDIT}`,
          d,
          { headers: h }
        );
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/B17");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun=()=>{
    if(!authors){
      setAuthorsErr(true)
      document.getElementById("authors").focus()
    }else if(!year){
      setYearErr(true)
      document.getElementById("year").focus()
    }else if(!Title){
      setTitleErr(true)
      document.getElementById("Title").focus()
    }else if(!magazineNewspaper){
      setMagazineNewspaperErr(true)
      document.getElementById("magazineNewspaper").focus()
    }else if(!pageno){
      setpagenoErr(true)
      document.getElementById("pageno").focus()
    }else{
      handleLeavepage()
    }
  }


  return (
    <div className="main-container-margin">
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>Popular articles (B17)</span>
        </div>
      </div>

      <form className="from-mains" onSubmit={handleSubmit(handleLeavepage)}>
        <div className="form-control">
          <h5 style={{ width: 450, margin: 20 }}>B17. Popular articles</h5>

          <TextField
            error={authorsErr}
            id="authors"
            label="Authors"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={authors}
            onChange={(e) => {
              setAuthors(e.target.value)
              setAuthorsErr(false)
            }}
          />

          <TextField
            error={yearErr}
            id="year"
            label="Year"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={year}
            onChange={(e) => {
              setYear(e.target.value)
              setYearErr(false)
            }}
          />

          <TextField
            error={TitleErr}
            id="Title"
            label="Title (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={Title}
            onChange={(e) => {
              setTitle(e.target.value)
              setTitleErr(false)
            }}
          />

          <TextField
            error={magazineNewspaperErr}
            id="magazineNewspaper"
            label=" Magazine/Newspaper (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={magazineNewspaper}
            onChange={(e) => {
              setMagazineNewspaper(e.target.value)
              setMagazineNewspaperErr(false)
            }}
          />

          <TextField
            error={pagenoErr}
            id="pageno"
            label="Page No"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={pageno}
            onChange={(e) => {
              setpageno(e.target.value)
              setpagenoErr(false)
            }}
          />

          {/* <TextField id="outlined-basic"
                        label="Place"
                        variant="outlined"
                        style={{ margin: '10px', width: "48%" }}

                        // value={NoOfStudent}
                        // onChange={(e) => setPlace(e.target.value)}

                    {...register("PlaceV")}
                    error={errors.PlaceV ? true : false}
                    helperText={errors.PlaceV?.message}
                    /> */}

          {/* <TextField id="outlined-basic"
                        label="Organizer"
                        variant="outlined"
                        style={{ margin: '10px', width: "48%" }}

                        // value={NoOfStudent}
                        onChange={(e) => setOrganizer(e.target.value)}

                
                        {...register("OrganizerV")}
                        error={errors.OrganizerV ? true : false}
                        helperText={errors.OrganizerV?.message}
                    /> */}

          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA", height: "20px" }}
              onClick={backs}
            >
              Back
            </button>
            <button type="submit" className="sbmit-buttons" onClick={()=>formValidateFun()}>
            Save
            </button>
          </div>

        </div>
      </form>
    </div>
  );
}

export default B17Inside;
